// src/components/Heading.tsx

import React from 'react';

interface HeadingProps {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    icon?: React.ReactNode;
    children: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ level = 1, icon, children }) => {
    const Tag = `h${level}` as keyof JSX.IntrinsicElements;

    return (
        <Tag className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 flex items-center">
            {icon && (
                <span className="mr-2 text-red-700">
          {icon}
        </span>
            )}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-700 to-black drop-shadow-lg">
        {children}
      </span>
        </Tag>
    );
};

export default Heading;